import type { PropsWithChildren } from 'react';

const ActionRow = ({ children }: PropsWithChildren): React.JSX.Element => {
    return (
        <div className="u-flex-box u-flex-box--row u-flex-box--center u-flex-box--justify-center-mobile">
            {children}
        </div>
    );
};

export default ActionRow;
